import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { OrderList } from './components';

export const OrdersPage: React.FC = () => {
  return (
    <Routes>
      <Route index element={<OrderList />} />
    </Routes>
  );
};
